import { Link } from "react-router-dom";
import { Icon } from "../../app/Icon";
import { BlogBreadcrumbs, BlogCover, BlogCta, BlogLayout } from "./BlogLayout";
import { formatPostDate } from "./posts";
import { sortedPosts } from "./seo";

export default function BlogHubPage() {
  const posts = sortedPosts();

  return <BlogLayout path="/blog">
    <main id="blog-main" className="blog-hub landing-wrap" tabIndex={-1}>
      <BlogBreadcrumbs />
      <header className="blog-hub__hero">
        <p className="blog-eyebrow"><span />THE STENCIL STUDIO BLOG</p>
        <h1>A little insight.<br /><em>A lot of ink.</em></h1>
        <p>Stories, ideas, and a closer look at tattoo culture.<br className="blog-desktop-break" /> For curious minds and creative hands.</p>
      </header>
      <section className="blog-list" aria-labelledby="blog-latest">
        <div className="blog-list__heading"><h2 id="blog-latest">Latest articles</h2><span>{posts.length} {posts.length === 1 ? "article" : "articles"}</span></div>
        <div className="blog-list__posts">
          {posts.map(post => <article key={post.slug} className="blog-card">
            <Link className="blog-card__link" to={`/blog/${post.slug}`} aria-labelledby={`post-${post.slug}`}>
              <BlogCover cover={post.cover} />
              <div className="blog-card__copy">
                <p className="blog-category">{post.category}<span aria-hidden="true">·</span><span>{post.readingMinutes} min read</span></p>
                <h3 id={`post-${post.slug}`}>{post.title}</h3>
                <p className="blog-card__excerpt">{post.excerpt}</p>
                <div className="blog-card__bottom"><time dateTime={post.publishedAt}>{formatPostDate(post.publishedAt)}</time><span className="blog-read-link">Read article<Icon name="arrow-right" /></span></div>
              </div>
            </Link>
          </article>)}
          {posts.length === 0 && <p className="blog-empty">Our first stories are on their way. Check back soon.</p>}
        </div>
      </section>
      <BlogCta />
    </main>
  </BlogLayout>;
}
